import { useState } from "react"
import { getOperatorCounts } from "../../../../api/operator/post"
import { Box, Button, TextField } from "@material-ui/core"
import { useHistory } from 'react-router-dom';
import handleNotfication from "../../../../utils/handleNotification";
import styles from './printModal.module.css'
const PrintModal = (props) => {
    const history = useHistory()
    const [count, setCount] = useState(0)

    const submit = (event: any) => {
        event.preventDefault();
        setCount(count)
        getOperatorCountsAction()
    }
    const getOperatorCountsAction = async () => {
        try {
            const { data } = await getOperatorCounts({ operatorId: props.selectedUser.user, count: count })
            const orderIds = data.listOrderDTOS.map(order => order.id);
            if (!!orderIds.length) { history.push(`/orders/receipt/bulk?ids=${orderIds.join(',')}`) }
            else {
                handleNotfication('سفارشی در لیست شما نیست','error')
            }

        } catch (error) {
            console.error(error)
        }
    }
    return (
        <Box className={styles.printWrapper} component="form" onSubmit={submit}>
            <TextField
                type="number"
                value={count}
                onChange={(e) => {
                    setCount(e.target.value)
                }}
                placeholder={`تعداد ...`}
                fullWidth
            />
            <Button size='large'
                type='submit'
                variant='contained'
                color='secondary'
                fullWidth>ثبت</Button>
        </Box>
    )
}
export default PrintModal